import styled from 'styled-components';
import {
  SecondaryButton,
  TertiaryButton,
} from '@grnhse/seedling/lib/birch/components/buttons';

const nowrapButtonStyles = `
  &&&& {
    white-space: nowrap;
    flex-shrink: 0;
  }
`;

export const NoWrapSecondaryButton = styled(SecondaryButton)`
  ${nowrapButtonStyles}
`;

export const NoWrapTertiaryButton = styled(TertiaryButton)`
  ${nowrapButtonStyles}
`;
